import { getIndexedLocationFilters, getMarketFromCityState } from '@atc/bonnet-reference';

const locationRegex = /^[A-Za-z]+(?:-[A-Za-z]+)*-[A-Za-z]{2}-\d{5}$/; // city-state-zip
const locationNozipRegex = /^[A-Za-z]+(?:[-.'][A-Za-z]+)*-[A-Za-z]{2}$/; // city-state

export const testUrlLocation = async (url) => {
    const splitPath = url.split('/');
    const locationSlug = splitPath.pop();

    const noZipLocationMatch = locationNozipRegex.test(locationSlug);
    const locationMatch = locationRegex.test(locationSlug);

    if (locationMatch || noZipLocationMatch) {
        const location = locationMatch ? locationSlug.slice(0, -6) : locationSlug; // drop the zip code if it matches the legacy pattern
        const state = location.slice(-3)?.replace('-', '').toUpperCase();
        const city = location.slice(0, -3);

        // confirm the slug is a known city-state by searching indexed locations and markets data
        const gilRes = await getIndexedLocationFilters({ city, state });

        if (gilRes.success) {
            return gilRes.success;
        }

        // I notice that the city name from markets is seperated by space not a dash, so we need to replace the dash with a space
        const cityWithSpace = city.replace(/-/g, ' ');
        const gmRes = await getMarketFromCityState({ city: cityWithSpace, state });

        return gmRes.success;
    }

    return locationMatch;
};

export default testUrlLocation;
